import React from "react";
import ReactDOM from "react-dom";
import { map, includes, sortBy, uniqBy, each, result, get } from "lodash";
// import data from "./data";

import { Select, Input, Table, Button} from "antd";
const Search = Input.Search;
const Option = Select.Option;

class TableComp extends React.Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    dataStore:[],
    currentData:[],
    filtered: false,
    searchText: ""
  };

  componentDidMount() {

      const {dataSource}  = this.props;

      console.log(dataSource);

      this.setState({
        dataStore:dataSource,
        currentData:dataSource,
      })
  }

  handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };
  handleFilter = (value, option) => {
    console.log(value);
    const {dataStore}  = this.state;

    this.setState({
      dataStore: map(dataStore, record => {
        const filterMatch = includes(record, value);
        if (!filterMatch) {
          return null;
        }
        return record;
      }).filter(record => !!record)
    });
  };
  getAdvancedFilters(filterKey) {
    let Filters = [];
    let title = sortBy(this.state.dataStore, filterKey);
    title = uniqBy(title, filterKey);

    each(title, e => {
      const filter = result(e, filterKey);
      Filters.push(<Option key={filter}>{filter}</Option>);
    });
    return Filters;
  }
  clearAll = () => {
        const {currentData}  = this.state;
    this.setState({
      filteredInfo: null,
      sortedInfo: null,
      dataStore: currentData,
      searchText: "",
      filtered: null
    });
  };
  emitEmpty = () => {
        const {dataStore}  = this.state;
    this.setState({
      dataStore: dataStore,
      searchText: "",
      filtered: null
    });
  };
  onInputChange = e => {
    this.setState({ searchText: e.target.value });
  };

  onSearch = e => {
    
    const {currentData}  = this.state; 

    const reg = new RegExp(e.target.value, "gi");
    const filteredData = map(currentData, record => {
      const nameMatch = get(record, "name").match(reg);
      const addressMatch = get(record, "email").match(reg);
      if (!nameMatch && !addressMatch) {
        return null;
      }
      return record;
    }).filter(record => !!record);

    this.setState({
      searchText: e.target.value,
      filtered: !!e.target.value,
      dataStore: e.target.value ? filteredData : currentData
    });
  };

  render() {
    let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};

    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        filteredValue: filteredInfo.name || null,
        onFilter: (value, record) => record.name.includes(value),
        sorter: (a, b) => (a.name > b.name ? 1 : -1),
        sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        sorter: (a, b) => a.role - b.role,
        sortOrder: sortedInfo.columnKey === "role" && sortedInfo.order
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        filteredValue: filteredInfo.email || null,
        onFilter: (value, record) => record.email.includes(value),
        sorter: (a, b) => a.email.length - b.email.length,
        sortOrder: sortedInfo.columnKey === "email" && sortedInfo.order
      }
    ];

    const docStatus = this.getAdvancedFilters("name");
    const docAddress = this.getAdvancedFilters("id");

    const { searchText } = this.state;
    const suffix = searchText ? (
      <span type="close-circle" onClick={this.emitEmpty} >CL </span>
    ) : null;
    return (
      <div>
        <div className="table-operations">
          <Search
            size="large"
            ref={ele => (this.searchText = ele)}
            suffix={suffix}
            onChange={this.onSearch}
            placeholder="Search Records"
            value={this.state.searchText}
            onPressEnter={this.onSearch}
          />

          <Button onClick={this.clearAll}>Clear all</Button>
          <Select
            notFoundContent={"Not found?!"}
            onChange={this.handleFilter}
            defaultValue={"Document Status"}
          >
            {docStatus}
          </Select>
          <Select
            onChange={this.handleFilter}
            showSearch
            placeholder={"Address"}
            defaultValue={"Document Address"}
          >
            {docAddress}
          </Select>
        </div>
        <Table
          columns={columns}
          dataSource={this.props.dataSource}
          rowKey={record => record.id}
          onChange={this.handleChange}
           pagination={true}
           className="ant-border-space"
        />
      </div>
    );
  }
}


export default TableComp;